import { Record } from '@opengov/compose-app/immutable';
import { composeStateMachine } from '../../../module/module';
var WizardState = Record({
  numberOfSteps: null,
  activeStepIndex: 1,
  isOnLastStep: false
});
export var wizardInitialState = WizardState();
export var wizardState = composeStateMachine('COMPONENT-LIBRARY-WIZARD', wizardInitialState, function (compose) {
  return {
    setNumberOfSteps: compose.action(function (state, payload) {
      return state.set('numberOfSteps', payload);
    }),
    incrementStep: compose.payloadlessAction(function (state) {
      var stepIncState = state.set('activeStepIndex', state.activeStepIndex < state.numberOfSteps ? state.activeStepIndex + 1 : state.numberOfSteps);
      return stepIncState.set('isOnLastStep', stepIncState.activeStepIndex === state.numberOfSteps);
    }),
    decrementStep: compose.payloadlessAction(function (state) {
      var stepIncState = state.set('activeStepIndex', state.activeStepIndex > 1 ? state.activeStepIndex - 1 : 1);
      return stepIncState.set('isOnLastStep', stepIncState.activeStepIndex === state.numberOfSteps);
    }),
    resetWizardState: compose.payloadlessAction(function (state) {
      return wizardInitialState;
    })
  };
});
var wizardActions = wizardState.actions,
    wizardActionCreators = wizardState.actionCreators,
    wizardReducer = wizardState.reducer,
    wizardSelector = wizardState.selector;
export { wizardActions, wizardActionCreators, wizardReducer, wizardSelector };